import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/ume logo.PNG";
import { useLanguage } from "../../contexts/LanguageContext";

const EVENTS_URL = "https://docs.google.com/forms/";
const FEEDBACK_URL = "https://docs.google.com/forms/d/1P5HjUPtihV-hHpnLIIFRqONrM7kW1eg7A5XkLTKm7Pg/edit?authuser=1";

const headerTranslations = {
  en: { help: 'Help', about: 'About Us', events: 'Events', feedback: 'Feedback', loginSignup: 'Get Early Access'},
  es: { help: 'Ayuda', about: 'Nosotros', events: 'Eventos', feedback: 'Comentario', loginSignup: 'Obtener acceso temprano' },
  tl: { help: 'Tulong', about: 'Tungkol sa Amin', events: 'Events', feedback: 'Feedback', loginSignup: 'Makakuha ng Early Access' }
};

const LandingHeader = ({ language: propLanguage, onLanguageChange, t }) => {
  const { language, setLanguage } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const activeLanguage = propLanguage || language;

  const translate = (key) => {
    if (t) {
      return t(`header.${key}`);
    }
    return headerTranslations[activeLanguage][key] || headerTranslations.en[key];
  };

  const handleChange = (e) => {
    const selected = e.target.value;
    if (onLanguageChange) {
      onLanguageChange(e);
    } else {
      setLanguage(selected);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="landing-header">
      <div className="landing-header-container">
        <div className="landing-header-left">
          <Link to="/" className="landing-logo-link" onClick={closeMobileMenu}>
            <img src={logo} alt="UME Health logo" className="landing-logo" />
          </Link>
        </div>

        <nav className="landing-nav">
          <a href="/help" className="nav-link">{translate('help')}</a>
          <a href="/about" className="nav-link">{translate('about')}</a>
          <a href={EVENTS_URL} className="nav-link" target="_blank" rel="noreferrer">{translate('events')}</a>
          <a href={FEEDBACK_URL} className="nav-link" target="_blank" rel="noreferrer">{translate('feedback')}</a>
          <select className="lang-select" value={activeLanguage} onChange={handleChange}>
            <option value="en">English</option>
            <option value="es">Spanish</option>
            <option value="tl">Tagalog</option>
          </select>
          <Link to="/login" className="header-button btn-primary">{translate('loginSignup')}</Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <a href="/help" className="mobile-nav-link" onClick={closeMobileMenu}>
            {translate('help')}
          </a>
          <a href="/about" className="mobile-nav-link" onClick={closeMobileMenu}>
            {translate('about')}
          </a>
          <a href={EVENTS_URL} className="mobile-nav-link" target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
            {translate('events')}
          </a>
          <a href={FEEDBACK_URL} className="mobile-nav-link" target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
            {translate('feedback')}
          </a>
          <div className="mobile-lang-select">
            <select className="lang-select" value={activeLanguage} onChange={handleChange}>
              <option value="en">English</option>
              <option value="es">Spanish</option>
              <option value="tl">Tagalog</option>
            </select>
          </div>
          <Link to="/registration" className="mobile-header-button" onClick={closeMobileMenu}>
            {translate('loginSignup')}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default LandingHeader;
